/* global document */

import React from 'react'
import ReactDOM from 'react-dom'
import { Router, Route, hashHistory } from 'react-router'

import Main from './Main'
import TokenLogin from './login/TokenLogin'
import OnboardingScreenManager from './login/OnboardingScreenManager'
import App from './App'
import Invoices from './billing/invoices/Invoices'
import Estimates from './billing/estimates/Estimates'
import Customers from './customer/CustomersContainer'
import Schedule from './schedule/Schedule'
import Team from './team/Team'
import ChatRooms from './chat/ChatRooms'
import Reports from './reports/Reports'
import Settings from './settings/Settings'
import './index.css'
import FirebaseConfig from './FirebaseConfig'

import * as firebase from 'firebase'

// Redux
import { Provider } from 'react-redux'
import { createStore, applyMiddleware } from 'redux'
import thunk from 'redux-thunk'
import AppReducer from './infra/AppReducer'
import MiscUtils from './infra/MiscUtils'
import Authorization from './infra/Authorization'

// Init Firebase
firebase.initializeApp(FirebaseConfig[MiscUtils.STAGE])
// Init Redux
const store = createStore(
  AppReducer,
  applyMiddleware(thunk)
)

const Member = Authorization(['member', 'manager', 'admin'])
const Manager = Authorization(['manager', 'admin'])
const Admin = Authorization(['admin'])

ReactDOM.render(
  <Provider store={store}>
    <Router history={hashHistory}>
      <Route path='/' component={Main}>
        <Route path='tokenlogin' component={TokenLogin}/>
        <Route path='login' component={OnboardingScreenManager}/>
        <Route path='app' component={Member(App)}>
          <Route path='customers' component={Admin(Customers)}/>
          <Route path='invoices' component={Admin(Invoices)}/>
          <Route path='estimates' component={Admin(Estimates)}/>
          <Route path='schedule' component={Manager(Schedule)}/>
          <Route path='team' component={Manager(Team)}/>
          <Route path='messages' component={Manager(ChatRooms)}/>
          <Route path='reports/:report' component={Manager(Reports)}/>
          <Route path='settings' component={Admin(Settings)}/>
        </Route>
      </Route>
    </Router>
  </Provider>,
  document.getElementById('root')
)



// WEBPACK FOOTER //
// ./src/index.js